<template>
  <div class="simple-timer">
    <svg class="simple-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g class="simple-timer__circle">
        <circle class="simple-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
        <path
            :stroke-dasharray="`${(timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`"
            class="simple-timer__path-remaining"
            :class="currColor"
            d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
        ></path>
      </g>
    </svg>
    <span class="simple-timer__label">{{ formattedTimeLeft }}</span>
  </div>
</template>

<script>

const TIME_LIMIT = 300;

export default {
  name: "SimpleTimer",
  props: {
    timeLimit: {
      type: Number,
      default: TIME_LIMIT
    }
  },
  data() {
    return {
      FULL_DASH_ARRAY: 283,
      WARNING_THRESHOLD: 30,
      ALERT_THRESHOLD: 10,
      COLOR_CODES: {
        info: {
          color: "green"
        },
        warning: {
          color: "orange",
          threshold: 30
        },
        alert: {
          color: "red",
          threshold: 10
        }
      },
      currColor: null,
      timePassed: 0,
      timerInterval: null,
      timeLeft: 0,
      timeFraction: 1
    };
  },

  computed: {
    formattedTimeLeft() {
      let minutes = Math.floor(this.timeLeft / 60);
      let seconds = this.timeLeft % 60;
      return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    }
  },
  methods: {
    setInitialTimerState() {
      this.timeLeft = this.timeLimit - this.timePassed
      clearInterval(this.timerInterval);
      this.remainingPathColor()
      this.setTimeFraction()
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        this.timePassed += 1
        this.timeLeft = this.timeLimit - this.timePassed
        this.remainingPathColor()
        this.setTimeFraction()
        if (this.timeLeft <= 0) {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    remainingPathColor() {
      const {alert, warning, info} = this.COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        this.currColor = alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        this.currColor = warning.color;
      } else {
        this.currColor = info.color;
      }
    },
    setTimeFraction() {
      const rawTimeFraction = this.timeLeft / this.timeLimit;
      this.timeFraction = rawTimeFraction - (1 / this.timeLimit) * (1 - rawTimeFraction);
    }
  },
  mounted() {
    this.setInitialTimerState()
    this.startTimer();
  }
};
</script>

<style scoped lang="scss">
.simple-timer {
  position: relative;
  width: 100px;
  height: 100px;

  &__svg {
    transform: scaleX(-1);
  }

  &__circle {
    fill: none;
    stroke: none;
  }

  &__path-elapsed {
    stroke-width: 7px;
    stroke: #EBEEF5;
  }

  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;

    &.green {
      color: rgb(65, 184, 131);
    }

    &.orange {
      color: orange;
    }

    &.red {
      color: red;
    }
  }

  &__label {
    position: absolute;
    width: 100px;
    height: 100px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 500;
  }
}
</style>
